import {css} from 'lit'; export default css`.sds-gallery-in-full-screen{position:fixed;width:100vw;height:100vh;top:0;left:0;z-index:10001}`;
    